/**
 * Short, human-readable "Name: message" for an unknown thrown value, for showing
 * on screen where no developer console is available (e.g. on a phone).
 */
export function describeError(error: unknown, maxLength = 200): string {
	let text: string;
	if (error instanceof Error) {
		text = error.message ? `${error.name}: ${error.message}` : error.name;
	} else if (
		typeof error === 'object' &&
		error !== null &&
		'message' in error
	) {
		// pdf.js and DOM errors are not always Error instances.
		const { name, message } = error as {
			name?: unknown;
			message?: unknown;
		};
		text = name ? `${String(name)}: ${String(message)}` : String(message);
	} else if (error instanceof Event) {
		text = `${error.type} event`;
	} else {
		text = String(error);
	}
	return text.length > maxLength ? `${text.slice(0, maxLength - 1)}…` : text;
}
